import { z } from "zod";

/**
 * Configure Zod to run in jitless mode to avoid Content Security Policy issues as we do not allow 'unsafe-eval'.
 * Must be called before zod is used.
 */
z.config({ jitless: true });
